import { Alert } from '@heroui/react';

interface CustomAlertProps {
  title?: string;
  description: string;
  hideIcon?: boolean;
  color?:
    | 'default'
    | 'primary'
    | 'secondary'
    | 'success'
    | 'warning'
    | 'danger';
  variant?: 'bordered' | 'flat' | 'faded' | 'solid';
  classNames?: { [key: string]: string };
  endContent?: React.ReactNode;
}

const CustomAlert = ({
  title = '',
  description = '',
  variant = 'faded',
  color = 'primary',
  endContent,
  hideIcon = false,
  classNames = {},
}: CustomAlertProps) => {
  return (
    <Alert
      variant={variant}
      color={color}
      description={description}
      title={title}
      classNames={{
        title: 'text-xs',
        description: 'text-xs',
        ...classNames,
      }}
      endContent={endContent}
      hideIcon={hideIcon}
    />
  );
};

export default CustomAlert;
